import React from "react";

export type TextProps = {
  className?: string;
  variant?: "p" | "span";
  size?:
    | "xxxs"
    | "xxs"
    | "xs"
    | "sm"
    | "md"
    | "lg"
    | "xl"
    | "2xl"
    | "3xl"
    | "lgx";
  children: React.ReactNode;
  style?: React.CSSProperties;
  withoutDefaultClass?: boolean;
};

const sizeClasses = {
  xxxs: "text-[0.70rem] tracking-[0.049em]",
  xxs: "text-[0.79rem]  tracking-[0.055em]",
  xs: "text-[0.9375rem] tracking-[0.035em]", // 15px
  sm: "text-[1.050rem] tracking-[0.035em]", // 16px
  md: "text-[1.125rem] font-semibold tracking-[0.035em]", // 18px
  lg: "text-[1.25rem] tracking-[0.035em]", // 20px
  lgx: "text-[1.5rem] tracking-[0.035em]", // 24px
  xl: "text-[1.52rem] font-[600] tracking-[0.035em]", // 28.8px
  "2xl": "text-[2.1rem] 2560px:text-[2.8rem] font-bold tracking-[0.005em]",
  "3xl": "text-[2rem] lg:text-[3.375rem] font-bold tracking-[0.005em]", // 32px / 70px (lg)
};

const Text = ({
  className = "",
  variant = "p",
  size = "md",
  children,
  style = {},
  withoutDefaultClass,
}: TextProps) => {
  const Element = variant;

  return (
    <Element
      style={style}
      className={` ${!withoutDefaultClass && "text-textColors-primary"} ${
        sizeClasses[size]
      } ${className}`}
    >
      {children}
    </Element>
  );
};

export default Text;
